import { ReactElement } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { getFeatureFlagDefinition } from '../flags';
import { FeatureUnavailablePage } from './FeatureUnavailablePage';
import { useFeatureFlag } from './FeatureFlagsProvider';

/**
 * Renders children only when the named runtime feature flag is enabled.
 * Reusable by any plugin — wrap page loaders with this gate.
 */
export function FeatureFlagGate(props: {
  flag: string;
  /** Optional override for the unavailable-page title. */
  featureName?: string;
  children: ReactElement;
}) {
  const { enabled, loading } = useFeatureFlag(props.flag);
  const definition = getFeatureFlagDefinition(props.flag);
  const featureName = props.featureName ?? definition?.title;

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (!enabled) {
    return <FeatureUnavailablePage featureName={featureName} />;
  }

  return props.children;
}
